// ArriveInfoView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import {
    DialogContent, DialogActions, Button,
    Grid,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { VzmPrint, VzmPrintHHMM } from '../../common/VzmStyled';
import DraggableViewer from '../../common/DraggableViewer';
import { ArriveInfoDictionary } from './ArriveInfoDict';
import { useAuthorizationCheck } from '../../api/app-hook';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10
});

const InputMap = ArriveInfoDictionary.inputMap;

/**
 * (ARRIVE_INFO) 정보 상세보기
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-28 14:38:37 using DbdbTap
 */
export default function ArriveInfoView({
    open,
    item,
    onRequestEdit,
    onClose
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    if(!open || !item) return null;

    const canEdit = checkAuth(authTableTree.tree.pr_arrive_info_edit);

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='md'
            title={
                <>
                <MenuBookIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>
                {item.dcName} 출발 - {item.storeName} 도착 &nbsp; [ {item.arriveId} ]
                </>
            }
        >
            <DialogContent>
                <ViewContainer>
                    <Grid container spacing={1}>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.dcName.label} value={item.dcName} />
                        </Grid>
                        <Grid item xs={4}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.storeName.label} value={item.storeName} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.dcCd.label + ' 코드'} value={item.dcCd} />
                        </Grid>
                        <Grid item xs={4}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.storeId.label + ' 코드'} value={item.storeId} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.dcTypeName.label} value={item.dcTypeName} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label="편도거리/왕복거리" value={`${item.distanceOne} / ${item.distanceRound}`} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.storeTypeName.label} value={item.storeTypeName} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrintHHMM label={InputMap.startReqTimeToday.label} value={item.startReqTimeToday} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrintHHMM label={InputMap.basicExpectRunTime.label} value={item.basicExpectRunTime} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrintHHMM label={InputMap.arriveReqTimeNext.label} value={item.arriveReqTimeNext} />
                        </Grid>
                        <Grid item xs={12}><hr style={{borderColor:'#fefefe'}}/></Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.basicDockno.label} value={item.basicDockno} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrintHHMM label={InputMap.firstShipTime.label} value={item.firstShipTime} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrintHHMM label={InputMap.lastShipTime.label} value={item.lastShipTime} />
                        </Grid>

                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.mainVehTypeName.label} value={item.mainVehTypeName} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.maxVehTypeName.label} value={item.maxVehTypeName} />
                        </Grid>
                        <Grid item xs={4}>
                            <VzmPrint label={InputMap.comName.label} value={item.comName} />
                        </Grid>
                        <Grid item xs={12}><hr style={{borderColor:'#fefefe'}}/></Grid>

                        <Grid item xs={3}>
                            <VzmPrint label="사용여부" value={item.useYn === 'Y' ? '사용' : '사용 중지'} />
                        </Grid>
                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.regTypeCd.label} value={item.regType} />
                        </Grid>
                        <Grid item xs={3}>
                            <VzmPrint label="자동배차" value={item.autoPlanYn === 'Y' ? '자동배차 사용' : '사용하지 않음'} />
                        </Grid>
                        <Grid item xs={3}>&nbsp;</Grid>

                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.autoPlanOrder.label} value={item.autoPlanOrder} />
                        </Grid>
                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.autoViewOrder.label} value={item.autoViewOrder} />
                        </Grid>

                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.pbsOrder.label} value={item.pbsOrder} />
                        </Grid>
                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.loadMaxCnt.label} value={item.loadMaxCnt} />
                        </Grid>


                        <Grid item xs={3}>
                            <VzmPrint label={InputMap.regUserName.label} value={item.regUserName} />
                        </Grid>
                        <Grid item xs={6}>
                            <VzmPrint label="등록" value={item.regDate} />
                        </Grid>

                    </Grid>

                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );

}